// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1brKb","boxTitle":"Qualiphy_boxTitle__2ZDnZ","box":"Qualiphy_box__3Gy5E","toggleWrap":"Qualiphy_toggleWrap__2Hrik"};